import React from "react";
import { Radio } from "@my-scoot/component-library-legacy";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import { onScrollToDiv } from "features/Common/utils/common.utils";
import { useOfferingVariationListStore } from "features/OfferingVariations/pages/OfferingVariationsList/store/useOfferingVariationList.store";
import { editVariationFieldMapping } from "../../utils/AddVariations.utils";
import { useAddVariations } from "../../utils/hooks/useAddVariation";

export const MembershipWiseVariationPricing = ({ offeringVariationData }) => {
  const { selectedOption, handleOptionChange } = useAddVariations({
    offeringVariationData,
  });
  const membershipListMap = useOfferingVariationListStore(
    (state) => state.membershipListMap
  );

  return (
    <div className="tw-w-full">
      <div className={"tw-mb-2 tw-font-medium"}>
        Pricing configurations for memberships:
      </div>
      {membershipListMap.map((membership, index) => {
        return (
          <>
            <Accordion
              className="!tw-rounded-[6px] !tw-border !tw-border-solid !tw-border-[#E5E8EC] !tw-mb-[16px] !tw-shadow-none"
              onChange={() =>
                onScrollToDiv({ elementId: membership?.id, block: "start" })
              }
              TransitionProps={{
                timeout: { enter: 0, exit: 0 }, // Set transition duration here
              }}
              classes={{
                root: "before:!tw-h-0",
              }}
              defaultExpanded={index === 0}
            >
              <AccordionSummary
                expandIcon={
                  <ArrowDropDownIcon className="!tw-text-[#1C1B1F]" />
                }
                aria-controls="panel1-content"
                id={membership?.id}
                className="!tw-bg-[#EBEEF2] !tw-p-[8px_0px_8px_12px] !tw-h-[50px] !tw-min-h-[20px] !tw-m-0 !tw-font-medium"
                classes={{
                  expanded: "!tw-m-0",
                  expandIcon: "!tw-pr-[20px]",
                }}
              >
                <div>{membership?.label}</div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="tw-grid tw-p-[12px_0px_16px_16px]">
                  {editVariationFieldMapping({
                    selectedOption,
                    handleOptionChange,
                    membershipId: membership?.id,
                  }).map((i) => (
                    <div key={i.label} className="d-flex mb-2">
                      <div className={"mr-2 tw-mt-[3px]"}>
                        <Radio onClick={i.onClick} checked={i.checked} />
                      </div>
                      <div className="flex-grow-1">
                        <span onClick={i.onClick} className={"pointer mr-1"}>
                          {i.label}
                        </span>
                        {i.belowLabel}
                      </div>
                    </div>
                  ))}
                </div>
              </AccordionDetails>
            </Accordion>
          </>
        );
      })}
    </div>
  );
};
